import type { MapboxIMap } from '..';

export const moveLayer: MapboxIMap['moveLayer'] = function (
  this: MapboxIMap,
  layerId,
  beforeLayerId
) {
  if (!this.hasLayer(layerId)) {
    throw new Error(`Layer ${layerId} does not exist`);
  }

  this._native.moveLayer(layerId, beforeLayerId);
};
